import { render, staticRenderFns } from "./importantEvent.vue?vue&type=template&id=31d64c47&scoped=true"
import script from "./importantEvent.vue?vue&type=script&lang=js"
export * from "./importantEvent.vue?vue&type=script&lang=js"
import style0 from "./importantEvent.vue?vue&type=style&index=0&id=31d64c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d64c47",
  null
  
)

export default component.exports